import styled from "styled-components";

export const BillingTypeConfigureTableWrapper = styled.div``;
